// src/components/Blog/BlogCard.js
import React from 'react';

const BlogCard = ({ post, darkMode, onReadMore }) => {
    return (
        <div
            className={`rounded-lg shadow p-4 mb-4 ${darkMode ? 'bg-gray-800 text-white' : 'bg-white'
                }`}
        >
            {post.mainImage && (
                <img
                    src={post.mainImage}
                    alt={post.title}
                    className="w-full h-48 object-cover rounded-lg mb-4"
                />
            )}
            <h3 className="font-semibold text-lg mb-2">{post.title}</h3>
            <p className={darkMode ? 'text-gray-300' : 'text-gray-600'}>{post.preview}</p>

            {post.tags && post.tags.length > 0 && (
                <div className="flex flex-wrap mt-3 mb-2">
                    {post.tags.map((tag, index) => (
                        <span
                            key={index}
                            className={`text-xs px-2 py-1 rounded-full mr-2 mb-1 ${darkMode ? 'bg-gray-700' : 'bg-gray-200'
                                }`}
                        >
                            {tag}
                        </span>
                    ))}
                </div>
            )}

            <div className="flex justify-between items-center mt-3">
                <span className={darkMode ? 'text-gray-400' : 'text-gray-500'}>{post.date}</span>
                <button
                    onClick={() => onReadMore(post.id)}
                    className="text-blue-500 hover:underline"
                >
                    Читать далее
                </button>
            </div>
        </div>
    );
};

export default BlogCard;